module.exports = __webpack_public_path__ + "img/katarina_kitchen_3.6cfd3210.jpg";